<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { MouseEventHandler } from 'svelte/elements';

  interface Props {
    href: string;
    target?: string;
    class?: string;
    customStyle?: boolean;
    children?: Snippet;
    onclick?: MouseEventHandler<HTMLAnchorElement>;
  }

  let { href, target = '_blank', customStyle = false, class: clazz, children, onclick }: Props = $props();

  const rel = $derived(target === '_blank' ? 'noopener noreferrer' : undefined);

  const linkClass = $derived(
    customStyle
      ? clazz
      : `
        text-blue-800 dark:text-blue-500 dark:hover:text-blue-700 hover:bg-blue-100
        focus:bg-blue-100 outline-hidden
        cursor-pointer
        ${clazz}
      `,
  );
</script>

<!-- eslint-disable svelte/no-navigation-without-resolve -->
<a class={linkClass} {href} {target} {rel} {onclick}>
  {@render children?.()}
</a>
